import axios from "axios";
import {
  LIST_SCHOOLS,
  SCHOOL,
  SCHOOL_BY_ID_FOR_PAYMENT,
  INITIATE_PAYMENT,
  SCHOOL_BY_ID,
  BASE_URL,
} from "../util/constants";
import { sendRequest } from "./base";

export const getAllSchools = async (data, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "POST", LIST_SCHOOLS, { Authorization });
  } catch (err) {
    return err;
  }
};

export const addSchool = async (data, token) => {
  const Authorization = `Bearer ${token}`;
  const options = {
    method: "POST",
    headers: {
      Authorization,
    },
    data: data,
    url: `${BASE_URL}/${SCHOOL}`,
  };
  try {
    const { data } = await axios(options);
    if (data) return data;
    throw new Error("Something went wrong please try again");
  } catch (error) {
    throw new Error(error);
  }
};

export const editSchool = async (data, id, token) => {
  const Authorization = `Bearer ${token}`;
  const options = {
    method: "PUT",
    headers: {
      Authorization,
    },
    data: data,
    url: `${BASE_URL}/${SCHOOL}?Id=${id}`,
  };
  try {
    const { data } = await axios(options);
    if (data) return data;
    throw new Error("Something went wrong please try again");
  } catch (error) {
    throw new Error(error);
  }
};

export const getSchoolById = async (id, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(null, "GET", `${SCHOOL}/byId?schoolId=${id}`, { Authorization });
  } catch (err) {
    return err;
  }
};

export const deleteSchool = async (id, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest({}, "DELETE", `${SCHOOL}?id=${id}`, { Authorization });
  } catch (err) {
    return err;
  }
};
export const searchSchools = async (data, SearchValue, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(
      data,
      "POST",
      `${LIST_SCHOOLS}?searchBy=${SearchValue}`,
      {
        Authorization,
      }
    );
  } catch (e) {
    return e;
  }
};

// export const searchSchoolById = async (data, schoolId, token) => {
//   const Authorization = `Bearer ${token}`;
//   try {
//     return sendRequest(data, "GET", `${SCHOOL_BY_ID}?schoolId=${schoolId}`, {
//       Authorization,
//     });
//   } catch (e) {
//     return e;
//   }
// };

export const searchSchoolById = async (schoolId) => {
  try {
    return sendRequest(
      null,
      "GET",
      `${SCHOOL_BY_ID_FOR_PAYMENT}?schoolId=${schoolId}`,
      null
    );
  } catch (err) {
    return err;
  }
};

export const searchSchoolByIdForPayment = async (schoolId) => {
  try {
    return sendRequest(
      null,
      "GET",
      `${SCHOOL_BY_ID_FOR_PAYMENT}?schoolId=${schoolId}`,
      null
    );
  } catch (err) {
    return err;
  }
};

export const initiatePaymentRequest = async (schoolId, amount, orderId) => {
  try {
    return sendRequest(
      null,
      "GET",
      `${INITIATE_PAYMENT}?schoolId=${schoolId}&amount=${amount}&orderId=${orderId}`,
      null
    );
  } catch (err) {
    return err;
  }
};


export const getSchoolByIdForPaymentLink = async (id) => {
  try {
    return sendRequest(null, "GET", `${SCHOOL}/schoolById?schoolId=${id}`, {});
  } catch (err) {
    return err;
  }
};